import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-clone",
  "use": "app-icon-clone-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"app-icon-clone\"><path d=\"M16 0H4v4H0v12h12v-4h4V0zm-6 14H2V6h2v6h6v2zm0-4H6V6h4v4zm4 0h-2V4H6V2h8v8z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol